var render = function render(){var _vm=this,_c=_vm._self._c;return _c('with-actions',[_c('change-logs-filters',{model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_c('change-logs-list',{attrs:{"filter":_vm.query},model:{value:(_vm.change_logs),callback:function ($$v) {_vm.change_logs=$$v},expression:"change_logs"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }